import { mode } from '@chakra-ui/theme-tools';

export const textStyles = {
  components: {
    Text: {
    	baseStyle: (props) => ({
	        fontSize: '16px',
		    color: mode('white', 'white')(props),
		    fontWeight: '400'
	    }),
	    variants: {
	    	'title-lg': (props) => ({
	   		  fontSize: '18px',
	          fontWeight: '600',
	          color: mode('blue.10', 'blue.10')(props),
	        }),
	    	'title': (props) => ({
	   		  fontSize: '16px',
	          fontWeight: '600',
	          color: mode('blue.10', 'blue.10')(props),
	        }),
	        'title-md': (props) => ({
	   		  fontSize: '14px',
	          fontWeight: '600',
	          color: mode('blue.10', 'blue.10')(props),
	        }),
	        'title-sm': (props) => ({
	   		  fontSize: '10px',
	          fontWeight: '600',
	          color: mode('blue.10', 'blue.10')(props),
	        }),
	        'text-lg': (props) => ({
	          fontSize: '18px',
	          fontWeight: '400',
	          color: mode('grey.10', 'grey.10')(props)
	        }),
	        'text': (props) => ({
	          fontSize: '16px',
	          fontWeight: '400',
	          color: mode('grey.10', 'grey.10')(props)
	        }),
	        'text-md': (props) => ({
	          fontSize: '14px',
		      fontStyle: 'normal',
			  fontWeight: '400',
			  color: mode('grey.10', 'grey.10')(props),
			  lineHeight: '20px'
	        }),
	        'text-sm': (props) => ({
	          fontSize: '12px',
		      fontStyle: 'normal',
			  fontWeight: '400',
			  color: mode('grey.10', 'grey.10')(props),
			  lineHeight: '20px'
	        }),
	        /* eslint-disable */
	        'sfpro': {
	        	fontFamily: 'SF Pro',
          		fontFeatureSettings: "'liga' off, 'clig' off",
	        }
	        /* eslint-enable */
	    }
    }
  },
};
